import { useEffect } from "react";

const CustomTooltip = () => {
    useEffect(() => {
        const tooltip = document.createElement("div");
        tooltip.className = "custom-tooltip";
        document.body.appendChild(tooltip);

        let timer: ReturnType<typeof setTimeout> | null = null;
        let currentTarget: HTMLElement | null = null;

       const handleMouseOver = (e: MouseEvent) => {
          const target = (e.target as HTMLElement)
              .closest(".tooltip-popup") as HTMLElement | null;

          if (!target) return;

          const title = target.getAttribute("title")?.trim();

          if (!title) return;

          currentTarget = target;

          // Remove browser's default tooltip immediately
          target.setAttribute("data-tooltip-text", title);
          target.removeAttribute("title");

          // Show custom tooltip immediately
          tooltip.textContent = title;
          tooltip.style.display = "block";
      };

        const handleMouseMove = (e: MouseEvent) => {
            if (tooltip.style.display === "block") {
                tooltip.style.left = `${e.clientX + 12}px`;
                tooltip.style.top = `${e.clientY + 12}px`;
            }
        };

        const handleMouseOut = (e: MouseEvent) => {
            const target = (e.target as HTMLElement)
                .closest("[data-tooltip-text]") as HTMLElement | null;

            if (!target) return;

            if (timer) {
                clearTimeout(timer);
                timer = null;
            }

            // Restore title for accessibility / next hover
            const title = target.getAttribute("data-tooltip-text");

            if (title) {
                target.setAttribute("title", title);
            }

            target.removeAttribute("data-tooltip-text");

            tooltip.style.display = "none";
            currentTarget = null;
        };

        document.addEventListener("mouseover", handleMouseOver);
        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseout", handleMouseOut);

        return () => {
            if (timer) clearTimeout(timer);

            document.removeEventListener("mouseover", handleMouseOver);
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseout", handleMouseOut);

            tooltip.remove();
        };
    }, []);

    return null;
};

export default CustomTooltip;